<template>
  <details-grid
    v-if="data.registries.length > 0"
    :title="title"
    :header="header"
    :rows="rows"
  />
  <div v-else class="d-none" :data-title="title"></div>
</template>

<script>
import DetailsGrid from "@/components/DetailsGrid";

// Anagrafica del movimento contabile: mostra solo i campi del tipo di
// anagrafica (field.status_registry) o quelli comuni a tutti i tipi.
export default {
  components: { DetailsGrid },
  props: {
    header: String,
    title: String,
    fields: Array,
    data: Object,
  },
  computed: {
    registry() {
      return this.data.registries[0];
    },
    rows() {
      return this.fields
        .filter(
          (field) =>
            field.status_registry === undefined ||
            field.status_registry === this.registry.status_registry.value
        )
        .map((field) => ({
          label: field.label,
          value: this.registry.attributables[field.value],
        }));
    },
  },
};
</script>
